import * as moment from 'moment';

export const appTimezone = 'America/Chicago';
export const date = moment.tz(new Date(), appTimezone);
export const dd = date.date();
export const mm = date.month() + 1;
export const yyyy = date.year();
export const time = date.format('h:mm:ss A');

export function convertToLongDate() {
  return date.format('MMMM');
};

export function expirationOneYearFromNow() {
  return date.add(1 , 'year').format('MM/DD/yyyy');
}

export function expirationOneYearFromNowLongDate() {
  return date.add(1 , 'year').format('MMMM DD, yyyy');
}

